"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(theme => ({
  button: {
    alignItems: "center",
    borderRadius: 48,
    border: "1px solid " + theme.palette.primary.main,
    color: theme.palette.primary.main,
    cursor: "pointer",
    display: "inline-flex",
    fontWeight: 700,
    gap: theme.spacing(1.5),
    justifyContent: "flex-start",
    letterSpacing: "1.6px",
    marginRight: "auto",
    minHeight: 48,
    padding: theme.spacing(1, 3),
    textTransform: "uppercase",
    "& span": {
      lineHeight: 1
    }
  }
}));
var _default = exports.default = styles;